module.exports = __webpack_public_path__ + "media/components/lesson2/common/images/animation_atlas_-0b898f1c3489bec58bf38958ed41a67b.png";